










import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import VueError from '@/components/VueError.vue';
import GroupAccessItem from '@/components/access/GroupAccessItem.vue';
import { Info } from '@/types/core';

@Component({
  components: {
    VueError,
    GroupAccessItem
  },
})
export default class GroupAccessEditSmall extends Vue {

  @Prop({ default: () => [],  type: Array}) startGroupIdList!: string[];
  @Prop({ default: {},  type: Object}) info!: Info;

  groupIdList:string[] = [];

  mounted() {
    // we copy over 
    this.groupIdList = this.startGroupIdList.concat();

    // if we have only 1 item let's auto select it
    if(this.info && this.info.fullGroupIdList && this.info.fullGroupIdList.length === 1) {
      //console.log(`forcing groupIdList to match ${this.info.fullGroupIdList.concat()}`);
      this.groupIdList = this.info.fullGroupIdList.concat();
    }
    
  }

  onChange() {
    this.$emit('update', this.groupIdList.concat());
  }

  get sortedGroupIdList():string[] {
    return this.info!.fullGroupIdList.sort((a, b) => this.extractEnterprise(a).localeCompare(this.extractEnterprise(b)));
  }

  extractEnterprise(groupId:string):string {
    let groupList = groupId.split('.');
    return groupList.length === 2 ? groupList[0] : groupId.split('.').slice(1, -1).join(' > ');
  }

}

